import React from "react";
import FacebookIcon from "../assets/facebook-icon.svg";
import InstagramIcon from "../assets/instagram-icon.svg";
import LinkedinIcon from "../assets/linkedin-icon.svg";
import "../sass/Contact.scss";

const Contact = () => {
 return (
  <div className="contact__page">
   <section className="section__one">
    <div className="container">
     <h2 className="section__title">
      Get in Touch. <span>We're Here</span> to Assist You.
     </h2>
     <p className="section__text center">
      Request a free consultation and discover how AirZones can help you create
      a healthier indoor environment.
     </p>
     <div className="section__body">
      <div className="sectionBody__left">
       <form action="">
        <input
         type="text"
         name=""
         id=""
         placeholder="Your Name"
         required
         className="input__field"
        />
        <input
         type="email"
         name=""
         id=""
         placeholder="Email Address"
         required
         className="input__field"
        />
        <input
         type="tel"
         name=""
         id=""
         placeholder="Phone Number (optional)"
         className="input__field"
        />
        <textarea
         name=""
         id=""
         placeholder="Message"
         className="input__field input__field--textarea"></textarea>
        <button className="button button--primary">
         <a href="">Send Message</a>
        </button>
       </form>
      </div>
      <div className="sectionBody__right">
       <div className="section__part">
        <h3>AirZones Europe</h3>
        <p>124 City Road, London EC1V 2NX,United Kingdom</p>
       </div>
       <div className="section__part">
        <h3>AirZones Middle East</h3>
        <p>
         #307,Building 6 Bay Square, Business Bay PO Box:75633, Dubai United
         Arab Emirates
        </p>
       </div>
       <div className="section__part">
        <p>
         Email: <a href="mailto:info@airzones.com">info@airzones.com</a>
        </p>
       </div>
       <div className="social__links">
        <a
         href="https://www.instagram.com/air.zones/"
         target="_blank"
         rel="noreferrer">
         <img src={InstagramIcon} alt="" />
        </a>
        <a
         href="https://www.facebook.com/airzones.uae"
         target="_blank"
         rel="noreferrer">
         <img src={FacebookIcon} alt="" />
        </a>
        <a
         href="https://www.linkedin.com/company/airzones/"
         target="_blank"
         rel="noreferrer">
         <img src={LinkedinIcon} alt="" />
        </a>
       </div>
      </div>
     </div>
    </div>
   </section>
  </div>
 );
};

export default Contact;
